<style scoped>
  .el-collapse-item__header {
      padding-left: 15px;
  }
  .el-upload--picture-card {
    float: left;
    margin-right: 10px;
} 
  .circle-closesty {
      position: relative;
    top: -35px;
    margin-left: 112px;
    font-size: 20px;
    cursor: pointer;
  }
  .v-modal {
    z-index: 100 !important;
  }
.title-box {
  display: flex;
  align-items: center;
  padding-left: 50px;
}
.title-box-name{
  width: 110px;
  flex-shrink: 0;
  text-align: right;
}
.title-box-name span {
  color: red;
}

.el-col-6{
  display: flex;
}
.ipt-sty{
  flex: 1;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"><div class="search-area-div required">所属公司</div> 
          <el-select size="mini" v-model="page.tenantGuid" placeholder="请选择" filterable class="ipt-sty " @change="companyChange">
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">医疗机构</div>
          <el-input size="mini" v-model="page.medName" class="ipt-sty" placeholder="请输入医疗机构标准名称" clearable></el-input
        ></el-col> 
        <el-col :span="6"
          ><div class="search-area-div">所属省份</div>
          <el-select  size="mini" filterable v-model="page.province" placeholder="请选择" class="ipt-sty " clearable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>    
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? "收起筛选" : "更多筛选" }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)"
            >搜索</el-button
          >
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-show="showMore" >
        <el-col :span="6"
          ><div class="search-area-div">其他名称</div>
          <el-input size="mini" v-model="page.medStandardName" class="ipt-sty" placeholder="请输入" clearable></el-input
        ></el-col> 
        <!-- <el-col :span="6"
          ><div class="search-area-div">维护状态</div>
          <el-select v-model="page.maintainState" placeholder="请选择" class="ipt-sty " clearable>
            <el-option v-for="item in maintenanceStatusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>   
        </el-col> -->
        <el-col :span="6"
          ><div class="search-area-div">机构类别</div> 
          <el-select v-model="page.orgTypes" placeholder="请选择" class="ipt-sty " clearable multiple collapse-tags>
            <!-- <el-option v-for="item in orgTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option> -->
            <el-option v-for="item in getCodeListByKey('医院分类')" :key="item.value" :label="item.text" :value="item.value"> </el-option>
          </el-select> 
        </el-col>

        <!-- <el-col :span="6"
        ><div class="search-area-div">建档方式</div>
        <el-select v-model="page.filingMethod" placeholder="请选择" class="ipt-sty " clearable>
          <el-option v-for="item in filingMethodList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>   
        </el-col>  -->
        <el-col :span="6">
          <div class="search-area-div">启用状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.bizStateList" placeholder="请选择" filterable multiple>
            <el-option v-for="item in bizStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">指派人员</div>
          <el-input
            size="mini"
            v-model="page.belongStaffName"
            class="ipt-sty"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">是否指派</div>
          <el-select size="mini" class="ipt-sty" v-model="page.isBelong" placeholder="请选择" filterable>
            <el-option v-for="item in isBelongOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">是否已清洗</div>
          <el-select size="mini" class="ipt-sty" v-model="page.isClear" placeholder="请选择" filterable>
            <el-option v-for="item in isClearList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">清洗结果</div>
          <el-select size="mini" class="ipt-sty" v-model="page.clearResult" placeholder="请选择" filterable>
            <el-option v-for="item in clearResultList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">更新后名称</div>
          <el-input
            size="mini"
            v-model="page.customerNameClear"
            class="ipt-sty"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">ID</div>
          <el-input
            size="mini"
            v-model="page.guid"
            class="ipt-sty"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
      </el-row> 
      <!-- <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">更新时间</div>
          <el-date-picker
            size="mini"
            v-model="updateTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">更新人</div>
          <el-input
            size="mini"
            v-model="page.updateName"
            class="ipt-sty"
            placeholder="请输入数据更新人姓名"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.approveState" placeholder="请选择" filterable>
            <el-option v-for="item in approveStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核时间</div>
          <el-date-picker
            size="mini"
            v-model="approveTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        
      </el-row> -->
    </div>   
    <div
      class="back-color-fff content-main-box"
      :style="'height:' + contentMainHeight + 'px;'"
    >
      <div class="button-area p16">
        <el-button v-if="getBtnPermissionsByName('添加医院')" icon="el-icon-plus" size="mini" type="info" @click="addPath">添加医院</el-button>
        <el-button v-if="getBtnPermissionsByName('批量导入')" icon="el-icon-plus" size="mini" type="info" @click="batchImport">批量导入</el-button> 
        <el-button v-if="getBtnPermissionsByName('批量导出')" size="mini" type="info" @click="report">批量导出</el-button>
        <el-button v-if="getBtnPermissionsByName('批量分配客户')" size="mini" @click="batchCustomer">批量分配客户</el-button>
        <!-- <el-button v-if="getBtnPermissionsByName('批量标记状态')" size="mini"  @click="openMiantainState(1)">批量标记状态</el-button>  -->
        
        <el-button v-if="getBtnPermissionsByName('批量导入更新状态')" size="mini"  @click="batchStateImport">批量导入更新状态</el-button>
        <el-button v-if="getBtnPermissionsByName('批量启用')" size="mini"  @click="batchChangeState('Y')">批量启用</el-button>
        <el-button v-if="getBtnPermissionsByName('批量停用')" size="mini"  @click="batchChangeState('S')">批量停用</el-button>
        <el-button
          v-if="getBtnPermissionsByName('数据清洗导入')"
          size="mini"
          class="fr"
          @click="cleanImport"
          >数据清洗导入</el-button
        >
        
      </div> 
        <el-table  
          :height="tableHeight" 
          v-if="orgRankList.length" 
          :data="tableData" 
          ref="multipleTable" 
          tooltip-effect="light"
          border 
          v-loading="tableLoading"  
          style="width:100%" 
          @selection-change="handleSelectionChange" 
          :row-key="(row) => row.guid" 
          @row-click="handleClickTableRow">
          <el-table-column type="selection" :reserve-selection="true" width="40" header-align="center" align="center">
          </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column :render-header="renderHeader" prop="medName" min-width="240" label="医疗机构标准名称" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.medName ||'-' }}
            </template>
          </el-table-column> 
          <el-table-column prop="orgType" width="120" label="机构类别" header-align="center"  align="left">
            <template slot-scope="scope">
              {{ getOrgTypeName(scope.row.orgType) }}
            </template> 
          </el-table-column>
          <el-table-column :render-header="renderHeader1" prop="medStandardName" min-width="240" label="其他名称" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.medStandardName||'-'}}
            </template> 
          </el-table-column>
          <el-table-column prop="orgRank" width="96" label="机构级次" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{getOrgRankName(scope.row.orgRank)}}
            </template> 
          </el-table-column>
          <el-table-column prop="orgGrade" width="96" label="机构等级" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.orgGrade | orgGrade}}
            </template> 
          </el-table-column>
          <!-- <el-table-column
          prop="updateName"
          label="更新人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.updateName || '-' }}</template>
        </el-table-column> -->
        <!-- <el-table-column width="160" prop="updateTime" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column> -->
        <!-- <el-table-column width="160" prop="approveTime" label="审核时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.approveTime | getTimeDate }}</template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="approveState"
          width="96"
          label="审核状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.approveState" :type="type[scope.row.approveState]">{{
              approveStateObj[scope.row.approveState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="bizState"
          width="96"
          label="启用状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.bizState" :type="type[scope.row.bizState]">{{
              bizStateObj[scope.row.bizState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>
          <!-- <el-table-column prop="region" label="大区" header-align="center" width="150" align="center">
            <template slot-scope="scope">{{ scope.row.region}}</template>
          </el-table-column>   -->
          <el-table-column prop="venue" width="120" label="省" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.province | province}}</template>
          </el-table-column> 
          <el-table-column prop="venue" width="120" label="市" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.city | city}}</template>
          </el-table-column> 
          <el-table-column prop="venue" width="120" label="区/县" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.district | district}}</template>
          </el-table-column> 
          <el-table-column prop="address" label="详细地址" min-width="240" header-align="center"  align="left" show-overflow-tooltip> 
            <template slot-scope="scope">
              {{ scope.row.address ||'-' }}
            </template>
          </el-table-column> 
          <el-table-column
            width="110"
            label="经度"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.lng || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            width="110"
            label="纬度"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.lat || "-" }}
            </template>
          </el-table-column>
          <el-table-column prop="contacts" width="96" label="医院联系人" header-align="center"  align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.contacts ||'-' }}
            </template>
          </el-table-column> 
          <el-table-column prop="contactTel" width="120" label="手机号码" header-align="center"  align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.contactTel ||'-' }}
            </template> 
          </el-table-column>
          <el-table-column prop="createUserName" width="120" label="业务指派人员" header-align="center"  align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ getbelongStaffsName(scope.row) }}
            </template>
          </el-table-column> 
          <!-- <el-table-column prop="contactTel" width="100" label="建档方式" header-align="center"  align="center">
                  <template slot-scope="scope">
              {{ scope.row.contactTel ||'-' }}
            </template> 
          </el-table-column> -->
          <!-- <el-table-column prop="contactTel" width="90" label="维护状态" header-align="center"  align="left">
            <template slot-scope="scope">
              {{ scope.row.maintainState | maintainState}}
            </template> 
          </el-table-column> -->
          <el-table-column 
            prop="medCode" 
            width="120" 
            label="医疗机构编码" 
            header-align="center" 
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.medCode ||'-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="guid"
            width="280"
            label="ID"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.guid || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="isClear"
            width="120"
            label="是否已清洗"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.isClear || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="customerNameClear"
            width="120"
            label="更新后医院名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.customerNameClear || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="lngClear"
            width="120"
            label="经度清洗"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.lngClear || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="latClear"
            width="120"
            label="纬度清洗"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.latClear || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="clearResult"
            width="120"
            label="清洗结果"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.clearResult || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="280" header-align="center"  align="center" fixed="right">
            <template slot-scope="scope">
              <div class="optionDiv" style="white-space: nowrap; display: inline-block">
              <a v-if="getBtnPermissionsByName('编辑')"  class="txt-color" @click.stop="editPath(scope.row.guid)">编辑 | </a> 
              <!-- <a v-if="scope.row.approveState === 'A' " class="txt-color" @click="toReview(scope.row)">
                审核 |
            </a> -->
            <!-- <a v-if="getBtnPermissionsByName('审核')" class="txt-color" @click="toReview(scope.row)">
                审核 |
            </a>
            <a v-if="scope.row.approveState === 'R' ||scope.row.approveState === 'Y'" class="txt-color" @click="toReview(scope.row)">
              撤回重审 |
            </a> -->
              <a v-if="getBtnPermissionsByName('维护医生')"  class="txt-color" @click.stop="goAddDoctor(scope.row)">维护医生 | </a>
              <a v-if="getBtnPermissionsByName('变更日志')" class="txt-color"  @click="changeLog(scope.row)">变更日志 | </a>
              <!-- <a v-if="getBtnPermissionsByName('标记状态')"  class="txt-color" @click.stop="openMiantainState(2,scope.row.guid)">标记状态 | </a> -->
              <a v-if="getBtnPermissionsByName('删除')"  class="txt-color" @click.stop="getDeleteData(2,scope.row.guid)">删除｜</a>
              <a  v-if="getBtnPermissionsByName('详情')" class="txt-color" @click.stop="editPath(scope.row.guid,true)">详情</a>
              </div>
            </template>
          </el-table-column>
        </el-table> 
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50,100,200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>   
    <el-dialog
      title="标记维护状态"
      :visible.sync="dialogVisible"
      width="400px">
      *维护状态：
      <el-radio-group v-model="maintainState">
        <el-radio :label="0">未处理</el-radio>
        <el-radio :label="1">已维护</el-radio>
        <el-radio :label="2">无需处理</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="info" @click="updateMiantainState()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量分配客户 -->
    <el-dialog title="批量分配客户" :visible.sync="dialogCustomer" width="550px" :close-on-click-modal="false">
      <div class="title-box">
        <div class="title-box-name"><span> </span>所属企业：</div>{{tenantName}}
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span> </span>已选客户：</div>
        <span class="fontC-4fa1a4">{{ `${this.multipleSelection.length}家(注意: 请在上个页面确认已选择的客户)` }}</span>
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span>*</span>指派人员：</div>
        <el-select v-model="staffForm.staffGuid" value-key="guid" multiple collapse-tags filterable placeholder="请选择" class="w60f" @change="changeStaff">
          <el-option
            v-for="item in staffList"
            :key="item.guid"
            :label="item.staffName"
            :value="item"
          >
          <span style="float: left">{{ item.staffName }}</span>
          <span span style="float: right; color: #8492a6; font-size: 13px">{{ item.mobileNo }}</span>
          </el-option>
        </el-select>
      </div>
      <!-- <div class="title-box mt15">
        <div class="title-box-name"><span> </span>所属部门：</div>{{organisationNames || '-'}}
        
      </div> -->
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogCustomer = false">取消</el-button>
        <el-button size="medium" v-loading.fullscreen.lock="fullscreenLoading" type="info" @click="submitFormStaff('2')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>  
import btnPermisson from '../mixins/btnPermisson';
import configuration  from './components/mixins/listMixins';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  mixins:[btnPermisson,configuration],
  data() {
    return {  
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 274,
      contentMainHeight:window.innerHeight - 200,
      isRefresh:false,
      orgRankList:[],
      dialogVisible: false, 
      options: areaJson,
      updateTime: [], // 更新时间
      approveTime: [], // 审核时间
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,  
        medName: '',  
        medStandardName: '',  
        tenantGuid:'',
        filingMethod:'',
        maintainState:'',
        orgTypes:[],
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
        belongStaffName:'',//指派人员
        isBelong:'',
        isClear: '',//是否清洗
        clearResult: '',//清洗结果
        customerNameClear: '',//更新后名称
        guid: '',//ID
      },  
      maintainState:1,
      tenantList:[],
      tableData:[],
      sendTime:'',
      right:'right',
      fullscreenLoading: false,
      tableLoading:false,
      filingMethodList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '手动建档'
        },
        {
          value: '2',
          label: '自动建档'
        }
      ],
      maintenanceStatusList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '0',
          label: '未处理'
        },
        {
          value: '1',
          label: '已维护'
        },
        {
          value: '2',
          label: '无需处理'
        }
      ],
      orgTypeList: [
        {
          value: '1',
          label: '医院'
        },
        {
          value: '2',
          label: '诊所'
        },
        {
          value: '3',
          label: '卫生院'
        },
        {
          value: '4',
          label: '社区卫生中心'
        }
      ],
      approveStateOp: [
        {
          text: '待审核',
          value: 'A',
        },
        {
          text: '已通过',
          value: 'Y',
        },
        {
          text: '已驳回',
          value: 'R',
        },
      ],
      bizStateOp: [
        
        {
          value: "S",
          text: "停用",
        },
        {
          value: "Y",
          text: "启用",
        },
      ],
      bizStateObj: {
        S: '停用',
        Y: '启用',
      },
      type: {
        A: 'warning',
        Y: 'success',
        R: 'danger',
        N: 'info',
        S: 'danger',
      },
      approveStateObj: {
        A: '待审核',
        Y: '已通过',
        R: '已驳回',
        N: '初始',
      },
      multipleSelectionGuid: [],
      multipleSelection: [],
      num:'',
      //新增分配
      dialogCustomer:false,
      tenantName:'',
      organisationNames:'',
      staffList:[],
      isBelongOp: [
        {
          value: "",
          text: "全部",
        },
        {
          value: "Y",
          text: "是",
        },
        {
          value: "N",
          text: "否",
        },
      ],
      /**是否已清洗 */
      isClearList: [
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      /**清洗结果 */
      clearResultList: [
        {
          value: "正常",
          label: "正常",
        },
        {
          value: "异常",
          label: "异常",
        },
      ],
    };
  },
  // beforeRouteLeave(to,from,next) {
  //   debugger
  //   if (to.path === '/hospitalLogs') {
  //     to.meta.keepAlive = true
  //     next(0)
  //   } else {
  //     next(0)
  //   }
  // },
  activated() {
    if (this.isRefresh) {
      this.getData();
    } else {
      this.isRefresh = true;
    }
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 374;
        this.contentMainHeight = window.innerHeight - 250;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 274;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  created() {
    this.getLevelList(2);
    this.getTenantOperationRelList(true);
    //按钮权限
    this.getMenuList();
  },
  methods: { 
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'light',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
              '机构工商注册名称'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    renderHeader1: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'light',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
              '机构曾用名、简称等'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
   
    getOrgRankName(value) {
      let orgRankList = this.orgRankList;
      let item = orgRankList.filter(item => item.value == value)
      return item.length && item[0].text || '-';
    },
    getOrgTypeName(value){
      // let orgTypeList = this.orgTypeList;
      let orgTypeList = this.getCodeListByKey('医院分类');
      let item = orgTypeList.filter(item => item.value == value)
      // return item.length && item[0].label || '-';
      return item.length && item[0].text || '-';
    },
    getLevelList(type) {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=${type == 1 ? '城市等级' : type == 2?'医院级别':'会议类型'}`,
        )
        .then((resp) => {
          console.log(resp.data);
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            data.forEach(item=>{
              item.value = item.value;
            })
            type == 1 ? this.cityLevelList = data : type == 2? this.orgRankList = data:this.meetingTypeList = data
          }
        });
    },
    //点击行选中
    handleClickTableRow(row, event, column){
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //批量分配
    batchCustomer(){
      if(!this.page.tenantGuid){
        this.$message.error('请先选择所属企业！')
        return
      }
      if(!this.tableData.length){
        this.$message.error('暂无数据！')
        return
      }
      if (!this.multipleSelection.length ) {
        this.$message.error('请勾选数据！');
        return
      }
      this.dialogCustomer = true;
    },
    //数据清洗导入
    cleanImport() {
      this.$router.push({
        path: '/dataCleaningImport',
        query: {
          type: '0043',
        }
      })
    },
    //批量停用、启用
    batchChangeState(flg) {
      // flg为停用(s)启用(Y)状态
      let str=''
      let tips=''
      let self = this;
      if (!this.multipleSelection.length) {
        this.$message.error("请勾选数据！");
        return;
      }
      if(flg==='S'){
        str='停用后，客户信息将不被服务人员看到，确定操作吗？'
        tips='批量停用成功'
      }else{
        str='启用后，负责该客户的服务人员将可以看到此信息，确定操作吗？'
        tips='批量启用成功'
      }
      
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        self.api
            .put(
              `/${serverConfig.msCustomerService}/common/update-biz-state?bizState=${flg}&customerType=4`,
              self.multipleSelection
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success(tips);
                self.$refs.multipleTable.clearSelection();
                self.getData(false);
              } else {
                self.$message.error(res.data.msg);
              }
            });
      })
    },
    companyChange(val){
      this.getStaff()
      this.tenantList.forEach(i=>{
        if(i.sendTenantGuid == val){
          this.tenantName = i.sendTenantName;
        }
      })
    },
    changeStaff(val){
    },
    getTenantOperationRelList(flg){ 
      let self = this;  
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true`+'&tenantGuid='+localStorage.guid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
          self.tenantList = res.data.data; 
          // if(self.tenantList && self.tenantList.length > 0){
          //   if(self.$route.query.tenantGuid){
          //     self.page.tenantGuid = self.$route.query.tenantGuid;
          //   }else{
          //     self.page.tenantGuid = self.tenantList[0].sendTenantGuid; 
          //   }
          //   self.getData(flg);
          // }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.postJson(`/${serverConfig.msCustomerService}/med/data/delete`, self.multipleSelection).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
              self.$message.success('删除成功');
              self.$refs.multipleTable.clearSelection();
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    openMiantainState(flg,guid){
      if(flg == 1){
        if (this.multipleSelection.length == 0) {
          this.$message.error('请勾选数据！');
          return
        }
      }
      this.dialogVisible = true;
      this.MiantainStateflg = flg;
      this.MiantainStateGuid = guid; 
    },
    updateMiantainState() {
      let self = this;
      let guids = []; 
      if(self.MiantainStateflg == 2){
        self.multipleSelection = [];
        self.multipleSelection.push(self.MiantainStateGuid);
      }
      this.$confirm('此操作将永久标记, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        self.api.put(`/${serverConfig.msCustomerService}/common/update-maintain-state?customerType=2&maintainState=`+self.maintainState,self.multipleSelection).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('标记成功');
            self.$refs.multipleTable.clearSelection();
            self.dialogVisible = false;
            self.getData(false);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
    empty() {
      let self = this; 
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,  
        medName: '',  
        medStandardName: '',  
        tenantGuid: this.page.tenantGuid,
        filingMethod:'',
        maintainState:'',
        orgTypes:[],
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
        belongStaffName:'',//指派人员
        isBelong:'',
        isClear: '',//是否清洗
        clearResult: '',//清洗结果
        guid: '',//ID
      },  
      self.getData(true);  
    }, 
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;  
      }  
      if(!this.page.tenantGuid ) {
        if(flg){
          this.$message.warning('请选择所属公司')
        }
        return;
      } 
      if(!this.page.bizStateList.length){
        this.page.bizStateList=['Y','S']
      }
      if(self.multipleSelection && self.multipleSelection.length > 0){
        self.$refs.multipleTable.clearSelection();
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/med/data/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    addPath(){
      this.$router.push({ path: '/medQueryDetail/detail', 
        query: { tenantGuid:this.page.tenantGuid, productGuid:this.$route.query.productGuid }
      });
    },
    editPath(guid,disabled){
      this.$router.push({ path: '/medQueryDetail/detail', 
        query: {
           guid: guid,
           tenantGuid:this.page.tenantGuid, 
           productGuid:this.$route.query.productGuid,
           disabled
        } 
      });
    },
    // 去审核
    toReview(item) {
      this.$router.push({
        path: `/medQueryAudit`,
        query: {
          guid: item.guid,
          tenantGuid: this.page.tenantGuid,
          productGuid: this.$route.query.productGuid,

        },
      });
    },
    goAddDoctor(detail) {
      console.log(detail);
      this.$router.push({
        path: 'doctorDetail',
        query: {
          medName: detail.medName,
          medGuid: detail.guid,
          province: detail.province,
          city: detail.city,
          district: detail.district,
          tenantGuid:detail.tenantGuid,
          productGuid:this.$route.query.productGuid
        }
      })
    },
    batchImport() {
      // this.$router.push({ path: '/importHospital' });
      this.$router.push({
        path: "/importNewManagementList",
        query: { 
          productGuid: this.$route.query.productGuid,
          type:'0010',
          tenantGuid:this.page.tenantGuid
        },
      });
    },
    batchStateImport() {
      this.$router.push({
        path: "/importNewStateList",
        query: { 
          productGuid: this.$route.query.productGuid,
          type:'0029',
          tenantGuid:this.page.tenantGuid
        },
      });
    },
    report(){
        let self = this;
          self.fullscreenLoading = true;
          let query = JSON.parse(JSON.stringify(self.page));
          query.pageSize = -1;
          // self.page.performanceGuid = self.$router.history.current.query.guid;
          self.api.postJson(`/${serverConfig.msCustomerService}/med/data/export-med-report`, query).then(res => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
              self.reportJx(res.data.data.colNames,res.data.data.datas,res.data.data.sheetName,res.data.data.fileNam);
            } else {
              self.$message.error(res.data.msg);
            }
          });
    }, 
    reportJx(colNames,datas,sheetName,fileNam){
        let self = this; 
        self.fullscreenLoading = true;
          self.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`,{'colNames':colNames,'datas':datas,'sheetName':sheetName,'fileNam':fileNam})
          .then(res => {  
             let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
              let fileName = fileNam;
              let objectUrl = URL.createObjectURL(blob);
              const link = document.createElement('a')
              link.download = fileName;
              link.href = objectUrl;
              link.click();
              self.fullscreenLoading = false;
          });
          // self.empty();
    },  
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
        self.staffForm.guids.push(item.guid)
      });
      console.log(val);
    }, 
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    getbelongStaffsName(row) {
      let { belongStaffs } = row
      if (Array.isArray(belongStaffs) && belongStaffs.length) {
        return belongStaffs.length > 2 ? `${((belongStaffs.slice(0, 2)).map(item=>item.staffName)).join()}等${belongStaffs.length}人` : (belongStaffs.map(item=>item.staffName)).join()
      } else {
        return '-'
      }
    },
    changeLog(row) {
      this.$router.push({
        path: "/hospitalLogs",
        query: {
          customerName: row.medName,
          customerGuid: row.guid,
          productGuid: this.$route.query.productGuid,
          configName:'YYJD_CONFIG'
        },
      });
    },
    
  },
};
</script> 
<style scoped>
/deep/ .el-table-column--selection .cell{
  padding-right:10px
}

.el-table /deep/ .el-input__inner {
     height: 40px; 
     line-height: 40px; 
}
.el-range-editor.el-input__inner { 
     padding: 0px; 
}
/deep/ .el-checkbox__label {
    display: none;
}
.attach-sty {
    width: 170px;
    float: left; 
    margin-top: 15px;
    text-align: center;
}
.checkbox-img-sty {
    border: 1px solid #DCDFE6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
}
/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
.search-area-div {
  flex-shrink: 0;
  margin-right: 4px;
  width: 72px;
  text-align:right
}
</style>
